import { render, staticRenderFns } from "./PurchaseVerify.vue?vue&type=template&id=bc4a132a&scoped=true&"
import script from "./PurchaseVerify.vue?vue&type=script&lang=js&"
export * from "./PurchaseVerify.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseVerify.vue?vue&type=style&index=0&id=bc4a132a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a132a",
  null
  
)

export default component.exports